import styled from 'styled-components';

const EditorStyle = styled.div`
	font-size: var(--p4);
	font-family: var(--montserrat_arm);
	font-weight: 400;
	line-height: var(--lineHeight);
	color: var(--textPrimaryColor);
	white-space: pre-wrap;

	h5 {
		font-size: var(--h2);
		font-family: var(--montserrat_medium);
		font-weight: 500;
		color: var(--textPrimaryColor);
		line-height: var(--lineHeightS);
	}

	h6 {
		font-size: var(--h5);
		font-family: var(--montserrat_medium);
		font-weight: 500;
		color: var(--textPrimaryColor);
		line-height: var(--lineHeightS);
	}

	p {
		font-size: var(--p4);
		font-family: var(--montserrat_arm);
		font-weight: 400;
		line-height: var(--lineHeight);
		color: var(--textPrimaryColor);
	}

	a {
		font-size: var(--p4);
		font-family: var(--montserrat_arm);
		font-weight: 400;
		line-height: var(--lineHeight);
		color: var(--textPrimaryColor);
		text-decoration: underline;

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					text-decoration: none;
				}
			}
		}
	}

	strong {
		font-weight: 600;
	}

	ol {
		list-style-position: inside;

		li {
			font-size: var(--p4);
			font-family: var(--montserrat_arm);
			font-weight: 400;
			line-height: var(--lineHeight);
			color: var(--textPrimaryColor);
		}
	}

	ul {
		list-style: disc;
		list-style-position: inside;

		li {
			font-size: var(--p4);
			font-family: var(--montserrat_arm);
			font-weight: 400;
			line-height: var(--lineHeight);
			color: var(--textPrimaryColor);
		}
	}

	blockquote {
		border-left: 3px solid var(--textPrimaryColor);
		padding-left: 2vw;
		font-size: var(--p4);
		font-family: var(--montserrat_arm);
		font-weight: 400;
		line-height: var(--lineHeight);
		color: var(--textPrimaryColor);
	}
`;

export default EditorStyle;
